import type { TranslationModule } from '../types';

export const usefulLinksTranslations: TranslationModule = {
  ro: {
    sectionTitle: "Hartă site",
    grileAudio: "Grile Audio",
    audioLegislatie: "Audio Legislație",
    legislatie: "Legislație",
    extrasCF: "Extras Carte Funciară",
    infiintareFirma: "Înființare Firmă",
    crm: "CRM Complex Online",
    stiriJuridice: "Știri Juridice",
    evenimente: "Evenimente",
    profesionisti: "Profesioniști",
    calculatoare: "Calculator Taxă Timbru",
    calculTermene: "Calculator Termene",
    calculContopiri: "Calculator Contopiri",
    calculLimite: "Calculator Limite Pedeapsă",
    perspectiveJuridice: "Perspective Juridice",
    analizaDocument: "Analiză Document",
    cariera: "Carieră",
    calculPrescriptie: "Calculator Prescripție Penală",
    calculReabilitare: "Calculator Reabilitare",
    calculSalariu: "Calculator Salariu Net",
    calculProcente: "Calculator Procente 2026"
  },
  en: {
    sectionTitle: "Site Map",
    grileAudio: "Audio Quizzes",
    audioLegislatie: "Audio Legislation",
    legislatie: "Legislation",
    extrasCF: "Land Registry Extract",
    infiintareFirma: "Company Incorporation",
    crm: "Complex CRM Online",
    stiriJuridice: "Legal News",
    evenimente: "Events",
    profesionisti: "Professionals",
    calculatoare: "Stamp Tax Calculator",
    calculTermene: "Deadlines Calculator",
    calculContopiri: "Sentence Merger Calculator",
    calculLimite: "Punishment Limits Calculator",
    perspectiveJuridice: "Legal Perspectives",
    analizaDocument: "Document Analysis",
    cariera: "Careers",
    calculPrescriptie: "Criminal Prescription Calculator",
    calculReabilitare: "Rehabilitation Calculator",
    calculSalariu: "Net Salary Calculator",
    calculProcente: "Percentage Calculator 2026"
  },
  fr: {
    sectionTitle: "Plan du Site",
    grileAudio: "QCM Audio",
    audioLegislatie: "Législation Audio",
    legislatie: "Législation",
    extrasCF: "Extrait du Registre Foncier",
    infiintareFirma: "Création d'Entreprise",
    crm: "CRM Complexe en Ligne",
    stiriJuridice: "Actualités Juridiques",
    evenimente: "Événements",
    profesionisti: "Professionnels",
    calculatoare: "Calculateur Droit de Timbre",
    calculTermene: "Calculateur Délais",
    calculContopiri: "Calculateur Fusion",
    calculLimite: "Calculateur Limites Peine",
    perspectiveJuridice: "Perspectives Juridiques",
    analizaDocument: "Analyse de Document",
    cariera: "Carrières",
    calculPrescriptie: "Calculateur Prescription Pénale",
    calculReabilitare: "Calculateur de Réhabilitation",
    calculSalariu: "Calculateur de Salaire Net",
    calculProcente: "Calculateur de Pourcentage 2026"
  }
};

export default usefulLinksTranslations;
